import { PropsWithChildren, useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux";
import { UserSettings } from "../../models/UserSettings";
import { RootState } from "../../store";
import { PaletteMode, ThemeProvider, createTheme } from "@mui/material";

export type ThemeWrapperProps = PropsWithChildren;

export function ThemeWrapper(props: ThemeWrapperProps) {
    const [mode, setMode] = useState<PaletteMode>("light");

    const theme = useMemo(() => createTheme({
      palette: {
        mode: mode,
      },
    }), [mode]);

    const settings = useSelector<RootState, UserSettings>(x => x.user.userSettings);

    useEffect(() => {
        setMode(settings.isDarkMode ? "dark" : "light");
    }, [settings]);

    return <ThemeProvider theme={theme}>
        {props.children}
    </ThemeProvider>
}